(function () {
function init() {
  var root = document.getElementById('obfaq');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  // Copy-link buttons are added here rather than in the markup to keep the section file small.
  if (root.getAttribute('data-copy-links') === 'true') {
    var icon = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="16" height="16"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var makeBtn = function (id, text, extra) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'obfaq__copy' + (extra ? ' ' + extra : '');
      b.setAttribute('data-copy', id);
      b.innerHTML = icon + '<span>' + text + '</span>';
      return b;
    };
    root.querySelectorAll('.obfaq__item').forEach(function (el) {
      el.querySelector('.obfaq__a').appendChild(makeBtn(el.id, 'Copy link to this answer'));
    });
    root.querySelectorAll('[data-category]').forEach(function (sec) {
      sec.querySelector('.obfaq__cat-head').appendChild(makeBtn(sec.id, 'Copy link', 'obfaq__copy--cat'));
    });
  }

  var items = Array.prototype.slice.call(root.querySelectorAll('.obfaq__item'));
  var cats = Array.prototype.slice.call(root.querySelectorAll('[data-category]'));
  var input = root.querySelector('#obfaq-search');
  var clearBtn = root.querySelector('.obfaq__search-clear');
  var status = root.querySelector('.obfaq__status');
  var noResults = root.querySelector('.obfaq__noresults');
  var toTop = root.querySelector('.obfaq__totop');
  var nav = root.querySelector('#faq-categories');
  var searching = false;

  function norm(s) {
    return s.toLowerCase().replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[–—]/g, '-');
  }

  // Keep the original markup so search highlights can be removed cleanly.
  var index = items.map(function (el) {
    var q = el.querySelector('.obfaq__q');
    var a = el.querySelector('.obfaq__a');
    return { el: el, q: q, a: a, qHtml: q.innerHTML, aHtml: a.innerHTML, text: norm(q.textContent + ' ' + a.textContent) };
  });

  // One answer open at a time within a category (not while searching).
  items.forEach(function (el) {
    el.addEventListener('toggle', function () {
      if (!el.open || searching) return;
      var list = el.parentNode.children;
      for (var i = 0; i < list.length; i++) if (list[i] !== el && list[i].open) list[i].open = false;
    });
  });

  function openFromHash(smooth) {
    var id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    var target = document.getElementById(id);
    if (!target || !root.contains(target)) return;
    if (searching) resetSearch();
    if (target.classList.contains('obfaq__item')) target.open = true;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    var focusEl = target.querySelector('summary, h2') || target;
    if (focusEl.tagName === 'H2') focusEl.setAttribute('tabindex', '-1');
    focusEl.focus({ preventScroll: true });
  }

  // In-page links (category menu, cross-links between sections) open the answer they point at.
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id || !document.getElementById(id)) return;
    e.preventDefault();
    if (location.hash.slice(1) === id) openFromHash(true);
    else { history.pushState(null, '', '#' + id); openFromHash(true); }
  });
  window.addEventListener('hashchange', function () { openFromHash(true); });

  // Copy-link buttons (handy for the Admin team when replying to customers).
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy]');
    if (!btn) return;
    var url = location.origin + location.pathname + '#' + btn.getAttribute('data-copy');
    var label = btn.querySelector('span');
    var original = label.textContent;
    function done(ok) {
      label.textContent = ok ? 'Link copied' : url;
      btn.classList.add('is-copied');
      setTimeout(function () { label.textContent = original; btn.classList.remove('is-copied'); }, 2500);
    }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
    else {
      var t = document.createElement('textarea');
      t.value = url; document.body.appendChild(t); t.select();
      var ok = false; try { ok = document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t); done(ok);
    }
  });

  // ---- search
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function highlight(node, re) {
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    var texts = [];
    while (walker.nextNode()) texts.push(walker.currentNode);
    texts.forEach(function (t) {
      var v = t.nodeValue;
      re.lastIndex = 0;
      if (!re.test(norm(v))) return;
      var frag = document.createDocumentFragment();
      var n = norm(v), last = 0, m;
      re.lastIndex = 0;
      while ((m = re.exec(n))) {
        if (m.index > last) frag.appendChild(document.createTextNode(v.slice(last, m.index)));
        var mark = document.createElement('mark');
        mark.textContent = v.slice(m.index, m.index + m[0].length);
        frag.appendChild(mark);
        last = m.index + m[0].length;
        if (!m[0].length) re.lastIndex++;
      }
      if (last < v.length) frag.appendChild(document.createTextNode(v.slice(last)));
      t.parentNode.replaceChild(frag, t);
    });
  }

  function restore() {
    index.forEach(function (r) {
      if (r.q.innerHTML !== r.qHtml) r.q.innerHTML = r.qHtml;
      if (r.a.innerHTML !== r.aHtml) r.a.innerHTML = r.aHtml;
    });
  }

  function setCounts(map) {
    root.querySelectorAll('.obfaq__cat-link').forEach(function (link) {
      var id = link.getAttribute('href').slice(1);
      var count = link.querySelector('.obfaq__cat-count');
      var total = +count.getAttribute('data-total');
      var n = map ? (map[id] || 0) : total;
      count.textContent = map ? n + ' of ' + total + ' match' : total + ' questions';
      link.classList.toggle('is-empty', !!map && n === 0);
    });
  }

  function resetSearch() {
    searching = false;
    input.value = '';
    clearBtn.hidden = true;
    restore();
    items.forEach(function (el) { el.hidden = false; el.open = false; });
    cats.forEach(function (c) { c.hidden = false; });
    noResults.hidden = true;
    status.textContent = '';
    setCounts(null);
    syncUrl('');
  }

  function syncUrl(q) {
    var url = new URL(location.href);
    if (q) url.searchParams.set('q', q); else url.searchParams.delete('q');
    history.replaceState(null, '', url.pathname + url.search + url.hash);
  }

  function runSearch(raw) {
    var q = norm(raw.trim());
    if (q.length < 2) { if (searching || !q) resetSearch(); input.value = raw; clearBtn.hidden = !raw; return; }
    searching = true;
    clearBtn.hidden = false;
    restore();
    var terms = q.split(/\s+/).filter(Boolean);
    var re = new RegExp(terms.map(escapeRe).join('|'), 'g');
    var perCat = {}, hits = [];
    index.forEach(function (r) {
      var match = terms.every(function (t) { return r.text.indexOf(t) !== -1; });
      r.el.hidden = !match;
      if (match) {
        hits.push(r);
        var cat = r.el.closest('[data-category]').id;
        perCat[cat] = (perCat[cat] || 0) + 1;
        highlight(r.q, re);
        highlight(r.a, re);
      }
    });
    cats.forEach(function (c) { c.hidden = !perCat[c.id]; });
    // Open the answers when there are only a few, so the match is visible straight away.
    hits.forEach(function (r) { r.el.open = hits.length <= 3; });
    noResults.hidden = hits.length > 0;
    status.textContent = hits.length === 0 ? 'No questions match “' + raw.trim() + '”.'
      : hits.length + (hits.length === 1 ? ' question matches' : ' questions match') + ' “' + raw.trim() + '”.' + (hits.length > 3 ? ' Tap a question to read the answer.' : '');
    setCounts(perCat);
    syncUrl(raw.trim());
  }

  var timer;
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var v = input.value;
    timer = setTimeout(function () { runSearch(v); }, 180);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); runSearch(input.value); }
    if (e.key === 'Escape') resetSearch();
  });
  clearBtn.addEventListener('click', function () { resetSearch(); input.focus(); });

  // Floating "back to categories" button once the menu has scrolled away.
  if ('IntersectionObserver' in window && toTop) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      toTop.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(nav);
  }

  var initial = new URLSearchParams(location.search).get('q');
  if (initial) { input.value = initial; runSearch(initial); }
  else if (location.hash) {
    if (document.readyState === 'complete') openFromHash(false);
    else window.addEventListener('load', function () { openFromHash(false); });
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();
